import { Checkbox, Chip, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useContext, useEffect, useMemo, useState } from 'react'
import { ProviderAccPayment } from '../../AccountingPayment/AccountingPaymentForm';
import CustomTablePagination from '../CustomTablePagination';
import TableTotal from './TableTotal';
import { numberFormatterLocale, parseFloatCheckValue, renderCellFileCustomTable } from '../../fnTickit';
import _ from "lodash";
import DialogPaymentSoldTicket from './DialogPaymentSoldTicket';
import { BtnRecall } from 'components/Button/ButtonAll';
import { I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';
import RenderCellFile from '../RenderCellFile';

const TablePaymentSoldTicket = ({menu,sIDPayment,getPaymentSoldTicket}) => {

    const {
        statusId,
        isView,
        objValue,
        setObjValue
    } = useContext(ProviderAccPayment);


    const dataTable = useMemo(() => {
        let lst = []
        if (objValue.lstSoldTicket != null && objValue.lstSoldTicket.length !== 0) {
            lst = objValue.lstSoldTicket;
        }
        return lst;
    }, [objValue.lstSoldTicket])

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selected, setSelected] = useState<readonly number[]>([]);

    const [isOpenRemark, setIsOpenRemark] = useState(false)
    const [rowClick, setRowClick] = useState(null)
    const [isOpenFile, setisOpenFile] = useState(false)
    const [arrFile, setarrFile] = useState([])

    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    useEffect(() => {
        setSelected(objValue.arrSelectTicketSold || [])
    }, [objValue.arrSelectTicketSold])


    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = dataTable.map((n) => n.nID);
            setSelected(newSelected);
            let sumTotal = _.sumBy(dataTable, function (o: any) { return parseFloatCheckValue(o.nTotal); });
            setObjValue(value => {
                return ({
                    ...value,
                    arrSelectTicketSold: newSelected,
                    nAmountTicketSold: sumTotal
                })
            })
            return;
        }
        const disableRow = dataTable.filter(f=>f.nStatusID === 2).map((n) => n.nID);
        setSelected(disableRow);
        let sumDisableTotal = _.sumBy(dataTable.filter(f=>f.nStatusID === 2), function (o: any) { return parseFloatCheckValue(o.nTotal); });
        setObjValue(value => {
            return ({
                ...value,
                arrSelectTicketSold: disableRow,
                nAmountTicketSold: sumDisableTotal
            })
        })
    };

    const handleClick = (id: number) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);

        let lstNotDelete = dataTable.filter(item => newSelected.includes(item.nID));
        let sumTotal = _.sumBy(lstNotDelete, function (o: any) { return parseFloatCheckValue(o.nTotal); });
        setObjValue(value => {
            return ({
                ...value,
                arrSelectTicketSold: newSelected,
                nAmountTicketSold: sumTotal
            })
        })
    };

    const handleClickFile = (row) => {
        setarrFile([{ sFileLink: row.sFileLink, sFileName: row.sFileName }])
        setisOpenFile(true)
    };

    const hasBtnReject = useMemo(() => {
        if(statusId === 0)
        {
            return false
        }

        let isHasReject = dataTable.findIndex(f=>f.nStatusID !== 2) > -1
        
        return isHasReject
    }, [dataTable,statusId])

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Divider textAlign="left"><Chip className='ticket-chip font-weight-500' label={"รายการจำหน่ายตั๋ว"}/></Divider>
            </Grid>
            <Grid item xs={12} >
                <TableContainer id="table-receive" component={Paper}>
                    <Table sx={{ minWidth: 800 }}>
                        <TableHead>
                            <TableRow >
                                {isView ? null : <TableCell
                                    className="td-center"
                                    padding="checkbox"
                                    style={{ minWidth: "60px", width: '60px' }}
                                >
                                    <Checkbox
                                        color="primary"
                                        indeterminate={selected.length > 0 && selected.length < dataTable.length}
                                        checked={dataTable.length > 0 && selected.length === dataTable.length}
                                        disabled={isView || !hasBtnReject}
                                        onChange={handleSelectAllClick}
                                        inputProps={{
                                            'aria-label': 'select all',
                                        }}
                                    />
                                </TableCell>}
                                <TableCell
                                    align="center"
                                    style={{ minWidth: "120px", width: "120px" }}
                                >
                                    วันที่จำหน่าย
                                </TableCell>
                                <TableCell
                                    align="center"
                                    style={{ minWidth: "100px", width: "100px" }}
                                >
                                    จำนวนเงินทั้งหมด (บาท)
                                </TableCell>
                                <TableCell
                                    align="center"
                                    style={{ minWidth: "220px", width: "220px" }}
                                >
                                    กรรมการตรวจสอบ
                                </TableCell>
                                <TableCell
                                    align="center"
                                    style={{ minWidth: "100px", width: "100px" }}
                                >
                                    เอกสารลงนาม
                                </TableCell>
                                <TableCell
                                    align="center"
                                    style={{ minWidth: "120px", width: "120px" }}
                                >
                                    สถานะ
                                </TableCell>
                                {
                                    statusId === 2 && hasBtnReject ?
                                        <TableCell
                                            align="center"
                                            style={{ minWidth: "160px", width: "160px" }}
                                        >

                                        </TableCell>
                                        : null
                                }
                            </TableRow>
                        </TableHead>
                        {dataTable.length > 0 ? (
                            <TableBody>
                                {dataTable
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row, index) => {
                                        let nNo = page * rowsPerPage + (index + 1);
                                        let isItemSelected = isSelected(row.nID);
                                        return (
                                            <TableRow key={nNo}>
                                                {isView ? null : <TableCell padding="checkbox" align="center">
                                                    <Checkbox
                                                        color="primary"
                                                        checked={isItemSelected}
                                                        disabled={row.nStatusID === 2}
                                                        onClick={() => handleClick(row.nID)}
                                                        inputProps={{
                                                            'aria-labelledby': `aria-${nNo}`
                                                        }}
                                                    />
                                                </TableCell>}
                                                <TableCell align="center">{row.sDateSold}</TableCell>
                                                <TableCell align="right">{numberFormatterLocale(row.nTotal, 2)}</TableCell>
                                                <TableCell align="left">{row.sNameCommittee}</TableCell>
                                                <TableCell align="center">
                                                    {row.sFileLink && renderCellFileCustomTable(nNo, row, handleClickFile)}
                                                </TableCell>
                                                <TableCell align="center">{row.sStatus}</TableCell>
                                                {
                                                    (row.nStatusID === 0 || row.nStatusID === 2) && menu === "Payment" && hasBtnReject ?
                                                        <TableCell align="center"></TableCell>
                                                        :
                                                        statusId === 2 && menu === "Payment" && hasBtnReject?
                                                            <TableCell align="center">
                                                                <BtnRecall
                                                                    id={`btnreject-${row.nID}`}
                                                                    txt={I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)}
                                                                    onClick={() => {
                                                                        setRowClick(row)
                                                                        setIsOpenRemark(true)
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            : null
                                                }
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        ) : (
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={isView ? 5 : 6}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </TableContainer>
                <CustomTablePagination
                    dataTable={dataTable}
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    page={page}
                    setPage={setPage}
                    colSpan={isView ? 5 : 6}
                    isShowDelete={selected.length > 0}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <TableTotal sTitle={"ยอดรวมจำหน่ายตั๋ว"} nValue={objValue.nAmountTicketSold} />
            </Grid>
            <RenderCellFile
                isOpen={isOpenFile}
                setIsOpen={setisOpenFile}
                arrFile={arrFile}
            />
            <DialogPaymentSoldTicket
                isOpenRemark={isOpenRemark}
                setIsOpenRemark={setIsOpenRemark}
                row={rowClick}
                sIDPayment={sIDPayment}
                getPaymentSoldTicket={getPaymentSoldTicket}
            />
        </Grid>
    )
}

export default TablePaymentSoldTicket